import Modal from "../../../global/components/Modal/Modal.vue";
import PuxButton from "../../../global/components/PuxButton/PuxButton.vue";
import PuxTranslate from "../../../global/components/PuxTranslate/PuxTranslate.vue";

import HttpMixin from "../../../global/mixins/HttpMixin";
import NotificationMixin from "../../../global/mixins/NotificationMixin";

// @vue/component
export default {
  name: "ProgrammeModalDeaktivieren",
  components: {
    Modal,
    PuxButton,
    PuxTranslate,
  },
  mixins: [
    HttpMixin,
    NotificationMixin,
  ],
  props: {
    programm: {
      type: Object,
      default: () => ({}),
    },
    close: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      modalOptions: {
        showCloseButton: true,
      },
      status: {
        loading: undefined,
      },
    };
  },
  methods: {
    deaktivieren() {
      this.status.loading = true;
      this.putHttp({ url: `foerderprogramme/${ this.programm.pk }/deaktivieren/` }).then(
        () => {
          this.addNotification({ text: "_MSG_PROGRAMME_MODAL_DEAKTIVIEREN_SUCCESS_" });
          this.close({ status: true });
        },
        () => this.addNotification({ text: "_MSG_PROGRAMME_MODAL_DEAKTIVIEREN_ERROR_", type: "error" })
      ).then(
        () => this.status.loading = false
      );
    },
  },
};
